import { api_get_team_users } from "../../../queries/users"


export const teamStoreActions = self => ({   
  async getMerchantTeam() {
    try {
      self.set('loading', true)
      const res = await api_get_team_users(self.token, self.merchantId)

      if (res.error) throw res


      const ids = await self.usersFactory.addUpdateUsers(res.data)
      self.set('teamUsers', ids)
      self.set('loading', false)
      return res.data

    } catch (err) {
      self.set('loading', false)
      console.log(err)
    }
  },

  set(key, value) {
    self[key] = value
  }
  })